import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';
import UploadItem from './UploadItem';

/**
 * UploadList component
 * Displays list of uploads with clear all functionality
 */
function UploadList({
  uploads,
  selectedProject,
  getProjectName,
  startUpload,
  resumeUpload,
  pauseUpload,
  cancelUpload,
  deleteUpload,
  dismissError,
  clearAllUploads,
}) {
  const { t } = useTranslation();
  
  if (uploads.length === 0) {
    return null;
  }

  return (
    <div className="uploads-section">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <h2 style={{ margin: 0 }}>{t('uploadsHistory')}</h2>
        <button
          onClick={clearAllUploads}
          className="clear-all-button"
          style={{
            padding: '8px 16px',
            background: '#f56565',
            color: '#ffffff',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#e53e3e';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = '#f56565';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          {t('clearAll')}
        </button>
      </div>
      <div className="uploads-list">
        {uploads.map(upload => (
          <UploadItem
            key={upload.sessionId}
            upload={upload}
            selectedProject={selectedProject}
            getProjectName={getProjectName}
            startUpload={startUpload}
            resumeUpload={resumeUpload}
            pauseUpload={pauseUpload}
            cancelUpload={cancelUpload}
            deleteUpload={deleteUpload}
            dismissError={dismissError}
          />
        ))}
      </div>
    </div>
  );
}

export default UploadList;

